
import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import stores from '@/stores';
import { mixin as Clickaway } from 'vue-clickaway';
import { SweetModal } from 'sweet-modal-vue';

@Component({
  components: {SweetModal},
  mixins: [ Clickaway ],
})
export default class EditAccount extends Vue {
  @Prop()
    acc!: IAccount;
  newAccount: IAccount = JSON.parse(JSON.stringify(this.acc));

  /**
   * Watches for the change in prop
   */
  @Watch('acc', { immediate: true })
    setModuleFromProps() {
      this.newAccount = JSON.parse(JSON.stringify(this.acc));
  }
  /**
   * Emits delete for the selected account
   */
  deleteAccount() {
    if (confirm('Do you really want to delete this account?')) {
      this.$emit('delete');
    }
  }
  /**
   * Emits save with the changed data
   */
  save() {
    this.$emit('save', this.newAccount);
  }

  /**
   * Closes the popup
   */
  cancel(): void {
    // @ts-ignore
    this.$children[0].close();
  }
}
